<template>
  <div>
    <div class="mt-3">
      <label class="block text-sm font-medium leading-5 text-gray-700">
        이미지 첨부
        <span class="text-gray-400 tracking-tighter">(최대 {{ max }}장)</span>
      </label>
    </div>
    <div
      @ondragover="onChange"
      @dragenter="dragging=true"
      @dragend="dragging=false"
      @dragleave="dragging=false"
      class="mt-1 flex justify-center border-2 border-gray-300 border-dashed rounded-md relative"
      :class="dragging ? 'dropAreaDragging' : ''"
    >
      <input
        id="file-input"
        type="file"
        multiple
        accept="image/*"
        @change="onChange"
        class="absolute w-full h-full opacity-0"
      >
      <div v-if="undeletedItems.length > 0" class="w-full p-3">
        <div class="grid grid-cols-3 gap-3">
          <div
            v-for="(item, i) in undeletedItems"
            :key="i"
            class="relative flex flex-col justify-center h-28 md:h-40 w-auto bg-white shadow p-2 rounded-md"
          >
            <button @click="deleteItem(i)" class="absolute top-0 right-0 m-1">
              <base-close size="h-4" class="text-gray-400">삭제</base-close>
            </button>
            <img :src="getPath(item.src)" class="max-h-full object-contain">
          </div>
        </div>
      </div>
      <div v-else class="my-6 text-center">
        <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
          <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
        <p class="mt-1 text-sm text-gray-600 mb-0">
          <label
            for="file-input"
            class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition duration-150 ease-in-out cursor-pointer"
          >
            이미지 파일을 선택
          </label>
          또는 드래그해서 놓으세요
        </p>
        <p class="mt-1 text-xs text-gray-500 mb-0">
          PNG, JPG, GIF
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import resizeImage from '../resizeImage'
import BaseClose from './BaseClose.vue'

export default {
  components: { BaseClose },

  props: {
    max: Number,
    files: Array,
  },

  data() {
    return {
      dragging: false,
      items: [],
    }
  },

  created() {
    if (this.files.length > 0) {
      this.items = this.files
    }
  },

  computed: {
    allowedCount() {
      return this.max - this.undeletedItems.length
    },

    undeletedItems() {
      return this.items.filter(x => x.mode !== 'delete')
    }
  },

  methods: {
    getPath(src) {
      if (src.substr(0, 4) === 'data') {
        return src
      }

      return `/storage/${src}`
    },

    deleteItem(i) {
      this.items[i].mode = 'delete'
      this.updateItems()
    },

    async onChange(e) {
      let files = e.target.files || e.dataTransfer.files;

      for (let x = 0; x < this.max; x++) {
        if (this.allowedCount === 0) {
          break
        }

        try {
          const resizedImage = await resizeImage({ file: files[x] })
          this.items.push({ mode: '', src: resizedImage })
        } catch(e) {
        }
      }

      this.updateItems()
    },

    updateItems() {
      this.$emit('selected', this.items)
    },
  }
}
</script>
